import { api, type PaginatedResponse } from './client';

export interface AuditoriaOut {
  id: string;
  actor_id: string | null;
  acao: string;
  alvo: string;
  metadados: Record<string, unknown>;
  ip: string | null;
  created_at: string;
  actor_type: string;
  origin: string;
  request_id: string | null;
  correlation_id: string | null;
  resource_id: string | null;
  outcome: string;
}

export type AuditoriaListResponse = PaginatedResponse<AuditoriaOut>;

export interface AuditoriaQueryParams {
  alvo?: string;
  acao?: string;
  actor_id?: string;
  outcome?: string;
  actor_type?: string;
  origin?: string;
  resource_id?: string;
  search?: string;
  data_inicio?: string;
  data_fim?: string;
  page?: number;
  page_size?: number;
}

export async function queryAuditoria(params: AuditoriaQueryParams): Promise<AuditoriaListResponse> {
  const { data } = await api.get<AuditoriaListResponse>('/auditoria', { params });
  return data;
}

export async function resolveUserIds(ids: string[]): Promise<Record<string, string>> {
  const { data } = await api.post<{ resolved: Record<string, string> }>(
    '/admin/users/resolve-ids',
    { ids },
  );
  return data.resolved;
}
